import { get, put } from "helpers/axios";
import { getBookingsUrl, getSingleBookingUrl, editBookingDetailsUrl } from "api/endpoints";

const getBookings = (query: string) => {
    return get(`${getBookingsUrl}?${query}`);
};

const getSingleBooking = (id: string, query: string) => {
    return get(getSingleBookingUrl + `/${id}?${query}`);
};

const editBookingDetails = (data: any) => {
    return put(editBookingDetailsUrl + `/${data.id}`, data);
}


const bookingsServices = {
    getBookings,
    getSingleBooking,
    editBookingDetails,
};

export default bookingsServices;
